import React, { memo } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import { LockIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import {
  getDisplayNameColorStyles,
  getLockIconColorStyles,
  indicatorStyles,
} from './FieldLockIndicator.styles';

const FieldLockIndicator = ({ displayName = '', userColor = null }) => (
  <Tooltip title={`Being edited by ${displayName}`}>
    <Box sx={indicatorStyles}>
      <Box sx={getLockIconColorStyles(userColor)}>
        <LockIcon size={14} />
      </Box>
      <Typography sx={getDisplayNameColorStyles(userColor)} variant="medium12">
        {displayName}
      </Typography>
    </Box>
  </Tooltip>
);

FieldLockIndicator.propTypes = {
  displayName: PropTypes.string.isRequired,
  userColor: PropTypes.string,
};

export default memo(FieldLockIndicator);
